import { Node } from '../Core/Node';
import { Element } from '../Dom/Element';
import { CanvasWrapper } from '../Wrapper/CanvasWrapper';

export interface IShapeOptions {
    lineWidth?: number;
    lineColor?: string;
}

export abstract class BaseShape extends Element {

    private _lineWidth: number; // 线宽
    private _lineColor: string; // 线颜色
    override target: CanvasWrapper;
    protected drawDirty: boolean = true;

    constructor(options: IShapeOptions = {}) {
        super();

        const {
            lineWidth = 1,
            lineColor = 'black'
        } = options;

        this._lineWidth = lineWidth;
        this._lineColor = lineColor;

        this.target = new CanvasWrapper(this);
    }

    get lineWidth(): number { return this._lineWidth; }
    get lineColor(): string { return this._lineColor; }

    // 重写 render，渲染目标元素
    override render(): void {

        if (this.drawDirty) {
            this.draw();
        }

        this.attachToDOM();
        this.updateTargetTransform();
    }

    protected abstract draw(): void;
}